import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Rohan Sharma",
    city: "Pune",
    vehicle: "Hyundai Creta · 2022",
    insurer: "ICICI Lombard",
    outcome: "Cashless · ₹1.2L approved",
    text: "I had a head-on collision on Pune-Mumbai expressway. Their tow arrived in 40 mins and the cashless claim was settled in 9 days. Honestly didn't expect this kind of service.",
    rating: 5,
    daysAgo: 9,
  },
  {
    name: "Priya Iyer",
    city: "Bengaluru",
    vehicle: "Maruti Swift · 2020",
    insurer: "HDFC ERGO",
    outcome: "Reimbursement · ₹68K",
    text: "I was earlier denied my claim because of a documentation gap. The team at myinsuranceclaim.in got it re-opened and approved within 3 weeks. Brilliant!",
    rating: 5,
    daysAgo: 18,
  },
  {
    name: "Aman Kapoor",
    city: "Delhi NCR",
    vehicle: "Honda City · 2019",
    insurer: "Bajaj Allianz",
    outcome: "Total Loss · IDV settled",
    text: "My car was completely written off. The claim manager handled RC transfer, salvage release, and IDV negotiation. I just signed papers. Felt premium and stress-free.",
    rating: 5,
    daysAgo: 32,
  },
];

function relativeDate(daysAgo) {
  const d = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000);
  const month = d.toLocaleString("en-IN", { month: "short" });
  return `${d.getDate()} ${month} ${d.getFullYear()}`;
}

function relativeAgo(daysAgo) {
  if (daysAgo < 7) return `${daysAgo} day${daysAgo === 1 ? "" : "s"} ago`;
  if (daysAgo < 30) return `${Math.round(daysAgo / 7)} week${daysAgo < 14 ? "" : "s"} ago`;
  const m = Math.round(daysAgo / 30);
  return `${m} month${m === 1 ? "" : "s"} ago`;
}

export default function Testimonials() {
  return (
    <section className="py-20 bg-white" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-[#FFF2E5] text-[#FF7A00] text-[10px] font-bold uppercase tracking-[0.2em] mb-3">
            Loved by 50,000+ policyholders
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
            Real claims. Real settlements. Real stories.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r) => (
            <div
              key={r.name}
              className="bg-gradient-to-b from-white to-[#F8FAFC] border border-slate-200 rounded-2xl p-6 hover-lift relative overflow-hidden"
              data-testid={`testimonial-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Quote className="absolute top-4 right-4 w-10 h-10 text-slate-100" />
              <div className="flex items-center gap-1 mb-3 justify-between">
                <div className="flex items-center gap-1">
                  {Array.from({ length: r.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#FF7A00] text-[#FF7A00]" />
                  ))}
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400" title={relativeDate(r.daysAgo)}>
                  {relativeAgo(r.daysAgo)}
                </span>
              </div>
              <p className="text-slate-700 leading-relaxed text-sm mb-5">"{r.text}"</p>
              <div className="border-t border-slate-100 pt-4">
                <div className="font-heading font-bold text-slate-900">{r.name}</div>
                <div className="text-xs text-slate-500">{r.city} · {r.vehicle}</div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-[#E6F0FF] text-[#003DA5]">
                    {r.insurer}
                  </span>
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-[#E6F9F0] text-[#00A86B]">
                    {r.outcome}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
